/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface RoutesService {
  /** @summary Search */
  searchRoutesSearchGet: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters, TMeta, TSignal>
        | (QueryFnOptionsByParameters<SearchRoutesSearchGetParameters, TMeta, TSignal> | void),
      client?: (
        schema: SearchRoutesSearchGetSchema,
        options: {
          parameters: SearchRoutesSearchGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchRoutesSearchGetData, SearchRoutesSearchGetError>>
    ): Promise<RequestFnResponse<SearchRoutesSearchGetData, SearchRoutesSearchGetError>>;
    /** @summary Search */
    getQueryKey(
      parameters: DeepReadonly<SearchRoutesSearchGetParameters> | void
    ): ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.searchRoutesSearchGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.searchRoutesSearchGet.useQuery({
     *     query: {
     *         start_at: startAt
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchRoutesSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchRoutesSearchGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query without parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.searchRoutesSearchGet.useQuery()
     * ```
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.searchRoutesSearchGet.useQuery({
     *     query: {
     *         start_at: startAt
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchRoutesSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options: Omit<
        DefinedInitialDataOptions<
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchRoutesSearchGetError>>;
    /** @summary Search */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchRoutesSearchGetParameters> | void
    ): ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.searchRoutesSearchGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_at: initialStartAt
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchRoutesSearchGetParameters,
      TQueryFnData = SearchRoutesSearchGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchRoutesSearchGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchRoutesSearchGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchRoutesSearchGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.searchRoutesSearchGet.useInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_at: initialStartAt
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchRoutesSearchGetParameters,
      TQueryFnData = SearchRoutesSearchGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchRoutesSearchGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchRoutesSearchGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchRoutesSearchGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchRoutesSearchGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchRoutesSearchGetTotal = qraft.routesService.searchRoutesSearchGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchRoutesSearchGetByParametersTotal = qraft.routesService.searchRoutesSearchGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             start_at: startAt
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchRoutesSearchGetResults = qraft.routesService.searchRoutesSearchGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_at: startAt1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_at: startAt2
     *             }
     *         }
     *     ]
     * });
     * searchRoutesSearchGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchRoutesSearchGetCombinedResults = qraft.routesService.searchRoutesSearchGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_at: startAt1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_at: startAt2
     *             }
     *         }
     *     ]
     * });
     * searchRoutesSearchGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchRoutesSearchGetSchema,
          SearchRoutesSearchGetParameters,
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchRoutesSearchGetData, SearchRoutesSearchGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<SearchRoutesSearchGetData, SearchRoutesSearchGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query without parameters
     * ```ts
     * const data = qraft.routesService.searchRoutesSearchGet.useSuspenseQuery()
     * ```
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.routesService.searchRoutesSearchGet.useSuspenseQuery({
     *     query: {
     *         start_at: startAt
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchRoutesSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchRoutesSearchGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.searchRoutesSearchGet.useSuspenseInfiniteQuery({}, {
     *     initialPageParam: {
     *         query: {
     *             start_at: initialStartAt
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchRoutesSearchGetParameters, TData = SearchRoutesSearchGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void),
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError,
          OperationInfiniteData<TData, SearchRoutesSearchGetParameters>,
          ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchRoutesSearchGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchRoutesSearchGetParameters>,
      OperationError<SearchRoutesSearchGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchRoutesSearchGetData = qraft.routesService.searchRoutesSearchGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 start_at: startAt1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_at: startAt2
     *             }
     *         }
     *     ]
     * });
     * searchRoutesSearchGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchRoutesSearchGetCombinedData = qraft.routesService.searchRoutesSearchGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 start_at: startAt1
     *             }
     *         },
     *         {
     *             query: {
     *                 start_at: startAt2
     *             }
     *         }
     *     ]
     * });
     * searchRoutesSearchGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchRoutesSearchGetSchema,
          SearchRoutesSearchGetParameters,
          SearchRoutesSearchGetData,
          SearchRoutesSearchGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchRoutesSearchGetData, SearchRoutesSearchGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<SearchRoutesSearchGetData, SearchRoutesSearchGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        SearchRoutesSearchGetError
      > | void
    ): Promise<SearchRoutesSearchGetData>;
    /** @summary Search */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        SearchRoutesSearchGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        SearchRoutesSearchGetError
      > | void
    ): Promise<SearchRoutesSearchGetData>;
    /** @summary Search */
    fetchInfiniteQuery<TPageParam extends SearchRoutesSearchGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchRoutesSearchGetError
      > | void
    ): Promise<OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>>;
    /** @summary Search */
    prefetchInfiniteQuery<TPageParam extends SearchRoutesSearchGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchRoutesSearchGetError
      > | void
    ): Promise<void>;
    /** @summary Search */
    ensureInfiniteQueryData<TPageParam extends SearchRoutesSearchGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        SearchRoutesSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchRoutesSearchGetError
      > | void
    ): Promise<OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>>;
    /** @summary Search */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void)
    ): SearchRoutesSearchGetData | undefined;
    /** @summary Search */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void)
    ): OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters> | undefined;
    /** @summary Search */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
            data:
              | NoInfer<OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>>
              | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
            data: SearchRoutesSearchGetData | undefined,
          ]
        >;
    /** @summary Search */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | (DeepReadonly<SearchRoutesSearchGetParameters> | void)
    ): QueryState<SearchRoutesSearchGetData, SearchRoutesSearchGetError> | undefined;
    /** @summary Search */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchRoutesSearchGetParameters>
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>
        | void
    ):
      | QueryState<
          OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>,
          SearchRoutesSearchGetError
        >
      | undefined;
    /** @summary Search */
    setQueryData(
      parameters:
        | (DeepReadonly<SearchRoutesSearchGetParameters> | undefined)
        | ServiceOperationQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
      updater: Updater<
        NoInfer<SearchRoutesSearchGetData> | undefined,
        NoInfer<DeepReadonly<SearchRoutesSearchGetData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchRoutesSearchGetData | undefined;
    /** @summary Search */
    setInfiniteQueryData(
      parameters:
        | (DeepReadonly<SearchRoutesSearchGetParameters> | undefined)
        | ServiceOperationInfiniteQueryKey<SearchRoutesSearchGetSchema, SearchRoutesSearchGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchRoutesSearchGetData, SearchRoutesSearchGetParameters> | undefined;
    /** @summary Search */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >,
      updater: Updater<NoInfer<SearchRoutesSearchGetData> | undefined, NoInfer<SearchRoutesSearchGetData> | undefined>,
      options?: SetDataOptions
    ): Array<SearchRoutesSearchGetData | undefined>;
    /** @summary Search */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchRoutesSearchGetSchema,
        SearchRoutesSearchGetData,
        TInfinite,
        SearchRoutesSearchGetParameters,
        SearchRoutesSearchGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
    ): void;
    /** @summary Search */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchRoutesSearchGetSchema,
            SearchRoutesSearchGetData,
            TInfinite,
            SearchRoutesSearchGetParameters,
            SearchRoutesSearchGetError
          >
    ): number;
    schema: SearchRoutesSearchGetSchema;
    types: {
      parameters: SearchRoutesSearchGetParameters;
      data: SearchRoutesSearchGetData;
      error: SearchRoutesSearchGetError;
    };
  };
  /** @summary Get */
  getRoutesRouteIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetRoutesRouteIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetRoutesRouteIdGetSchema,
        options: {
          parameters: GetRoutesRouteIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>>
    ): Promise<RequestFnResponse<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetRoutesRouteIdGetParameters>
    ): ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.getRoutesRouteIdGet.useQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRoutesRouteIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError,
          TData,
          ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetRoutesRouteIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.routesService.getRoutesRouteIdGet.useQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetRoutesRouteIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError,
          TData,
          ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetRoutesRouteIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetRoutesRouteIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.getRoutesRouteIdGet.useInfiniteQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetRoutesRouteIdGetParameters,
      TQueryFnData = GetRoutesRouteIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetRoutesRouteIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRoutesRouteIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetRoutesRouteIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.getRoutesRouteIdGet.useInfiniteQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetRoutesRouteIdGetParameters,
      TQueryFnData = GetRoutesRouteIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetRoutesRouteIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetRoutesRouteIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetRoutesRouteIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetRoutesRouteIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getRoutesRouteIdGetTotal = qraft.routesService.getRoutesRouteIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getRoutesRouteIdGetByParametersTotal = qraft.routesService.getRoutesRouteIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             route_id: routeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getRoutesRouteIdGetResults = qraft.routesService.getRoutesRouteIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 route_id: routeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 route_id: routeId2
     *             }
     *         }
     *     ]
     * });
     * getRoutesRouteIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getRoutesRouteIdGetCombinedResults = qraft.routesService.getRoutesRouteIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 route_id: routeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 route_id: routeId2
     *             }
     *         }
     *     ]
     * });
     * getRoutesRouteIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetRoutesRouteIdGetSchema,
          GetRoutesRouteIdGetParameters,
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.routesService.getRoutesRouteIdGet.useSuspenseQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetRoutesRouteIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError,
          TData,
          ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetRoutesRouteIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.routesService.getRoutesRouteIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         route_id: routeId
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetRoutesRouteIdGetParameters, TData = GetRoutesRouteIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError,
          OperationInfiniteData<TData, GetRoutesRouteIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetRoutesRouteIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetRoutesRouteIdGetParameters>,
      OperationError<GetRoutesRouteIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getRoutesRouteIdGetData = qraft.routesService.getRoutesRouteIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 route_id: routeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 route_id: routeId2
     *             }
     *         }
     *     ]
     * });
     * getRoutesRouteIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getRoutesRouteIdGetCombinedData = qraft.routesService.getRoutesRouteIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 route_id: routeId1
     *             }
     *         },
     *         {
     *             path: {
     *                 route_id: routeId2
     *             }
     *         }
     *     ]
     * });
     * getRoutesRouteIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetRoutesRouteIdGetSchema,
          GetRoutesRouteIdGetParameters,
          GetRoutesRouteIdGetData,
          GetRoutesRouteIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        GetRoutesRouteIdGetError
      >
    ): Promise<GetRoutesRouteIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        GetRoutesRouteIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        GetRoutesRouteIdGetError
      >
    ): Promise<GetRoutesRouteIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetRoutesRouteIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRoutesRouteIdGetError
      >
    ): Promise<OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetRoutesRouteIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRoutesRouteIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetRoutesRouteIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        GetRoutesRouteIdGetParameters,
        DeepReadonly<TPageParam>,
        GetRoutesRouteIdGetError
      >
    ): Promise<OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>
    ): GetRoutesRouteIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>
    ): OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
            data: NoInfer<OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
            data: GetRoutesRouteIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
        | DeepReadonly<GetRoutesRouteIdGetParameters>
    ): QueryState<GetRoutesRouteIdGetData, GetRoutesRouteIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetRoutesRouteIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>,
          GetRoutesRouteIdGetError
        >
      | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetRoutesRouteIdGetParameters>
        | ServiceOperationQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
      updater: Updater<
        NoInfer<GetRoutesRouteIdGetData> | undefined,
        NoInfer<DeepReadonly<GetRoutesRouteIdGetData>> | undefined
      >,
      options?: SetDataOptions
    ): GetRoutesRouteIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetRoutesRouteIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetRoutesRouteIdGetSchema, GetRoutesRouteIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetRoutesRouteIdGetData, GetRoutesRouteIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >,
      updater: Updater<NoInfer<GetRoutesRouteIdGetData> | undefined, NoInfer<GetRoutesRouteIdGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetRoutesRouteIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetRoutesRouteIdGetSchema,
        GetRoutesRouteIdGetData,
        TInfinite,
        GetRoutesRouteIdGetParameters,
        GetRoutesRouteIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
        | QueryFiltersByQueryKey<
            GetRoutesRouteIdGetSchema,
            GetRoutesRouteIdGetData,
            TInfinite,
            GetRoutesRouteIdGetParameters,
            GetRoutesRouteIdGetError
          >
    ): number;
    schema: GetRoutesRouteIdGetSchema;
    types: {
      parameters: GetRoutesRouteIdGetParameters;
      data: GetRoutesRouteIdGetData;
      error: GetRoutesRouteIdGetError;
    };
  };
  /** @summary Update */
  updateRoutesRouteIdPatch: {
    /** @summary Update */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateRoutesRouteIdPatchBody,
        UpdateRoutesRouteIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateRoutesRouteIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateRoutesRouteIdPatchBody,
          UpdateRoutesRouteIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<UpdateRoutesRouteIdPatchData, UpdateRoutesRouteIdPatchError>>
    ): Promise<RequestFnResponse<UpdateRoutesRouteIdPatchData, UpdateRoutesRouteIdPatchError>>;
    /** @summary Update */
    getMutationKey(
      parameters: DeepReadonly<UpdateRoutesRouteIdPatchParameters> | void
    ): ServiceOperationMutationKey<UpdateRoutesRouteIdPatchSchema, UpdateRoutesRouteIdPatchParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.updateRoutesRouteIdPatch.useMutation({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.updateRoutesRouteIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         route_id: routeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends UpdateRoutesRouteIdPatchBody, TContext = unknown>(
      parameters: DeepReadonly<UpdateRoutesRouteIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateRoutesRouteIdPatchSchema,
        UpdateRoutesRouteIdPatchData,
        UpdateRoutesRouteIdPatchParameters,
        TVariables,
        OperationError<UpdateRoutesRouteIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateRoutesRouteIdPatchData,
      OperationError<UpdateRoutesRouteIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.updateRoutesRouteIdPatch.useMutation({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.updateRoutesRouteIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         route_id: routeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<UpdateRoutesRouteIdPatchBody, UpdateRoutesRouteIdPatchParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateRoutesRouteIdPatchSchema,
        UpdateRoutesRouteIdPatchData,
        UpdateRoutesRouteIdPatchParameters,
        TVariables,
        OperationError<UpdateRoutesRouteIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateRoutesRouteIdPatchData,
      OperationError<UpdateRoutesRouteIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateRoutesRouteIdPatchTotal = qraft.routesService.updateRoutesRouteIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateRoutesRouteIdPatchTotal = qraft.routesService.updateRoutesRouteIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             route_id: routeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateRoutesRouteIdPatchSchema,
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateRoutesRouteIdPatchPendingMutationVariables = qraft.routesService.updateRoutesRouteIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateRoutesRouteIdPatchMutationData = qraft.routesService.updateRoutesRouteIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 route_id: routeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateRoutesRouteIdPatchData,
        OperationError<UpdateRoutesRouteIdPatchError>,
        MutationVariables<UpdateRoutesRouteIdPatchBody, UpdateRoutesRouteIdPatchParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateRoutesRouteIdPatchSchema,
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateRoutesRouteIdPatchData,
          OperationError<UpdateRoutesRouteIdPatchError>,
          MutationVariables<UpdateRoutesRouteIdPatchBody, UpdateRoutesRouteIdPatchParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Update */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateRoutesRouteIdPatchSchema,
            UpdateRoutesRouteIdPatchBody,
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchParameters,
            OperationError<UpdateRoutesRouteIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.routesService.updateRoutesRouteIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             route_id: routeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.routesService.updateRoutesRouteIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateRoutesRouteIdPatchBody,
              UpdateRoutesRouteIdPatchData,
              UpdateRoutesRouteIdPatchParameters,
              OperationError<UpdateRoutesRouteIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateRoutesRouteIdPatchSchema,
              UpdateRoutesRouteIdPatchBody,
              UpdateRoutesRouteIdPatchData,
              UpdateRoutesRouteIdPatchParameters,
              OperationError<UpdateRoutesRouteIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateRoutesRouteIdPatchData,
            UpdateRoutesRouteIdPatchError,
            MutationVariables<UpdateRoutesRouteIdPatchBody, UpdateRoutesRouteIdPatchParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateRoutesRouteIdPatchBody,
              UpdateRoutesRouteIdPatchData,
              UpdateRoutesRouteIdPatchParameters,
              OperationError<UpdateRoutesRouteIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateRoutesRouteIdPatchSchema,
              UpdateRoutesRouteIdPatchBody,
              UpdateRoutesRouteIdPatchData,
              UpdateRoutesRouteIdPatchParameters,
              OperationError<UpdateRoutesRouteIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateRoutesRouteIdPatchData,
          UpdateRoutesRouteIdPatchError,
          MutationVariables<UpdateRoutesRouteIdPatchBody, UpdateRoutesRouteIdPatchParameters>,
          TContext
        >
      >;
    };
    schema: UpdateRoutesRouteIdPatchSchema;
    types: {
      parameters: UpdateRoutesRouteIdPatchParameters;
      data: UpdateRoutesRouteIdPatchData;
      error: UpdateRoutesRouteIdPatchError;
      body: UpdateRoutesRouteIdPatchBody;
    };
  };
  /** @summary Delete */
  deleteRoutesRouteIdDelete: {
    /** @summary Delete */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        DeleteRoutesRouteIdDeleteBody,
        DeleteRoutesRouteIdDeleteParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: DeleteRoutesRouteIdDeleteSchema,
        options: ServiceOperationMutationFnOptions<
          DeleteRoutesRouteIdDeleteBody,
          DeleteRoutesRouteIdDeleteParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<DeleteRoutesRouteIdDeleteData, DeleteRoutesRouteIdDeleteError>>
    ): Promise<RequestFnResponse<DeleteRoutesRouteIdDeleteData, DeleteRoutesRouteIdDeleteError>>;
    /** @summary Delete */
    getMutationKey(
      parameters: DeepReadonly<DeleteRoutesRouteIdDeleteParameters> | void
    ): ServiceOperationMutationKey<DeleteRoutesRouteIdDeleteSchema, DeleteRoutesRouteIdDeleteParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.deleteRoutesRouteIdDelete.useMutation({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.deleteRoutesRouteIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         route_id: routeId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends DeleteRoutesRouteIdDeleteBody, TContext = unknown>(
      parameters: DeepReadonly<DeleteRoutesRouteIdDeleteParameters>,
      options?: ServiceOperationUseMutationOptions<
        DeleteRoutesRouteIdDeleteSchema,
        DeleteRoutesRouteIdDeleteData,
        DeleteRoutesRouteIdDeleteParameters,
        TVariables,
        OperationError<DeleteRoutesRouteIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteRoutesRouteIdDeleteData,
      OperationError<DeleteRoutesRouteIdDeleteError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.deleteRoutesRouteIdDelete.useMutation({
     *     path: {
     *         route_id: routeId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.deleteRoutesRouteIdDelete.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         route_id: routeId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<DeleteRoutesRouteIdDeleteBody, DeleteRoutesRouteIdDeleteParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        DeleteRoutesRouteIdDeleteSchema,
        DeleteRoutesRouteIdDeleteData,
        DeleteRoutesRouteIdDeleteParameters,
        TVariables,
        OperationError<DeleteRoutesRouteIdDeleteError>,
        TContext
      >
    ): UseMutationResult<
      DeleteRoutesRouteIdDeleteData,
      OperationError<DeleteRoutesRouteIdDeleteError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const deleteRoutesRouteIdDeleteTotal = qraft.routesService.deleteRoutesRouteIdDelete.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const deleteRoutesRouteIdDeleteTotal = qraft.routesService.deleteRoutesRouteIdDelete.useIsMutating({
     *     parameters: {
     *         path: {
     *             route_id: routeId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteRoutesRouteIdDeleteSchema,
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const deleteRoutesRouteIdDeletePendingMutationVariables = qraft.routesService.deleteRoutesRouteIdDelete.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const deleteRoutesRouteIdDeleteMutationData = qraft.routesService.deleteRoutesRouteIdDelete.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 route_id: routeId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        DeleteRoutesRouteIdDeleteData,
        OperationError<DeleteRoutesRouteIdDeleteError>,
        MutationVariables<DeleteRoutesRouteIdDeleteBody, DeleteRoutesRouteIdDeleteParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteRoutesRouteIdDeleteSchema,
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          DeleteRoutesRouteIdDeleteData,
          OperationError<DeleteRoutesRouteIdDeleteError>,
          MutationVariables<DeleteRoutesRouteIdDeleteBody, DeleteRoutesRouteIdDeleteParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Delete */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            DeleteRoutesRouteIdDeleteSchema,
            DeleteRoutesRouteIdDeleteBody,
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteParameters,
            OperationError<DeleteRoutesRouteIdDeleteError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Delete
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.routesService.deleteRoutesRouteIdDelete.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             route_id: routeId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.routesService.deleteRoutesRouteIdDelete.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              DeleteRoutesRouteIdDeleteBody,
              DeleteRoutesRouteIdDeleteData,
              DeleteRoutesRouteIdDeleteParameters,
              OperationError<DeleteRoutesRouteIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteRoutesRouteIdDeleteSchema,
              DeleteRoutesRouteIdDeleteBody,
              DeleteRoutesRouteIdDeleteData,
              DeleteRoutesRouteIdDeleteParameters,
              OperationError<DeleteRoutesRouteIdDeleteError>,
              TContext
            >
      ):
        | Mutation<
            DeleteRoutesRouteIdDeleteData,
            DeleteRoutesRouteIdDeleteError,
            MutationVariables<DeleteRoutesRouteIdDeleteBody, DeleteRoutesRouteIdDeleteParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              DeleteRoutesRouteIdDeleteBody,
              DeleteRoutesRouteIdDeleteData,
              DeleteRoutesRouteIdDeleteParameters,
              OperationError<DeleteRoutesRouteIdDeleteError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              DeleteRoutesRouteIdDeleteSchema,
              DeleteRoutesRouteIdDeleteBody,
              DeleteRoutesRouteIdDeleteData,
              DeleteRoutesRouteIdDeleteParameters,
              OperationError<DeleteRoutesRouteIdDeleteError>,
              TContext
            >
      ): Array<
        Mutation<
          DeleteRoutesRouteIdDeleteData,
          DeleteRoutesRouteIdDeleteError,
          MutationVariables<DeleteRoutesRouteIdDeleteBody, DeleteRoutesRouteIdDeleteParameters>,
          TContext
        >
      >;
    };
    schema: DeleteRoutesRouteIdDeleteSchema;
    types: {
      parameters: DeleteRoutesRouteIdDeleteParameters;
      data: DeleteRoutesRouteIdDeleteData;
      error: DeleteRoutesRouteIdDeleteError;
      body: DeleteRoutesRouteIdDeleteBody;
    };
  };
  /** @summary Create */
  createRoutesPost: {
    /** @summary Create */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<CreateRoutesPostBody, CreateRoutesPostParameters, TMeta, TSignal>,
      client?: (
        schema: CreateRoutesPostSchema,
        options: ServiceOperationMutationFnOptions<CreateRoutesPostBody, CreateRoutesPostParameters, TMeta, TSignal>
      ) => Promise<RequestFnResponse<CreateRoutesPostData, CreateRoutesPostError>>
    ): Promise<RequestFnResponse<CreateRoutesPostData, CreateRoutesPostError>>;
    /** @summary Create */
    getMutationKey(
      parameters: DeepReadonly<CreateRoutesPostParameters> | void
    ): ServiceOperationMutationKey<CreateRoutesPostSchema, CreateRoutesPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.createRoutesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.createRoutesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<TVariables extends CreateRoutesPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateRoutesPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateRoutesPostSchema,
        CreateRoutesPostData,
        CreateRoutesPostParameters,
        TVariables,
        OperationError<CreateRoutesPostError>,
        TContext
      >
    ): UseMutationResult<CreateRoutesPostData, OperationError<CreateRoutesPostError>, TVariables, TContext>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.createRoutesPost.useMutation({})
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.routesService.createRoutesPost.useMutation()
     * mutate({
     *     body: bodyPayload
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<CreateRoutesPostBody, CreateRoutesPostParameters>,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateRoutesPostSchema,
        CreateRoutesPostData,
        CreateRoutesPostParameters,
        TVariables,
        OperationError<CreateRoutesPostError>,
        TContext
      >
    ): UseMutationResult<CreateRoutesPostData, OperationError<CreateRoutesPostError>, TVariables, TContext>;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createRoutesPostTotal = qraft.routesService.createRoutesPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createRoutesPostTotal = qraft.routesService.createRoutesPost.useIsMutating({
     *     parameters: {}
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateRoutesPostSchema,
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createRoutesPostPendingMutationVariables = qraft.routesService.createRoutesPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createRoutesPostMutationData = qraft.routesService.createRoutesPost.useMutationState({
     *     filters: {
     *         parameters: {}
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateRoutesPostData,
        OperationError<CreateRoutesPostError>,
        MutationVariables<CreateRoutesPostBody, CreateRoutesPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateRoutesPostSchema,
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateRoutesPostData,
          OperationError<CreateRoutesPostError>,
          MutationVariables<CreateRoutesPostBody, CreateRoutesPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Create */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateRoutesPostSchema,
            CreateRoutesPostBody,
            CreateRoutesPostData,
            CreateRoutesPostParameters,
            OperationError<CreateRoutesPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.routesService.createRoutesPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {}
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.routesService.createRoutesPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateRoutesPostBody,
              CreateRoutesPostData,
              CreateRoutesPostParameters,
              OperationError<CreateRoutesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateRoutesPostSchema,
              CreateRoutesPostBody,
              CreateRoutesPostData,
              CreateRoutesPostParameters,
              OperationError<CreateRoutesPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateRoutesPostData,
            CreateRoutesPostError,
            MutationVariables<CreateRoutesPostBody, CreateRoutesPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateRoutesPostBody,
              CreateRoutesPostData,
              CreateRoutesPostParameters,
              OperationError<CreateRoutesPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateRoutesPostSchema,
              CreateRoutesPostBody,
              CreateRoutesPostData,
              CreateRoutesPostParameters,
              OperationError<CreateRoutesPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateRoutesPostData,
          CreateRoutesPostError,
          MutationVariables<CreateRoutesPostBody, CreateRoutesPostParameters>,
          TContext
        >
      >;
    };
    schema: CreateRoutesPostSchema;
    types: {
      parameters: CreateRoutesPostParameters;
      data: CreateRoutesPostData;
      error: CreateRoutesPostError;
      body: CreateRoutesPostBody;
    };
  };
}
/** @summary Search */
export const searchRoutesSearchGet = {
  schema: {
    method: 'get',
    url: '/routes/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchRoutesSearchGetSchema;
  [QraftServiceOperationsToken]: RoutesService['searchRoutesSearchGet'];
};
/** @summary Get */
export const getRoutesRouteIdGet = {
  schema: {
    method: 'get',
    url: '/routes/{route_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetRoutesRouteIdGetSchema;
  [QraftServiceOperationsToken]: RoutesService['getRoutesRouteIdGet'];
};
/** @summary Update */
export const updateRoutesRouteIdPatch = {
  schema: {
    method: 'patch',
    url: '/routes/{route_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateRoutesRouteIdPatchSchema;
  [QraftServiceOperationsToken]: RoutesService['updateRoutesRouteIdPatch'];
};
/** @summary Delete */
export const deleteRoutesRouteIdDelete = {
  schema: {
    method: 'delete',
    url: '/routes/{route_id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: DeleteRoutesRouteIdDeleteSchema;
  [QraftServiceOperationsToken]: RoutesService['deleteRoutesRouteIdDelete'];
};
/** @summary Create */
export const createRoutesPost = {
  schema: {
    method: 'post',
    url: '/routes',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateRoutesPostSchema;
  [QraftServiceOperationsToken]: RoutesService['createRoutesPost'];
};
export const routesService = {
  searchRoutesSearchGet,
  getRoutesRouteIdGet,
  updateRoutesRouteIdPatch,
  deleteRoutesRouteIdDelete,
  createRoutesPost,
} as const;
type SearchRoutesSearchGetSchema = {
  method: 'get';
  url: '/routes/search';
  security: ['HTTPBearer'];
};
type SearchRoutesSearchGetParameters = paths['/routes/search']['get']['parameters'];
type SearchRoutesSearchGetData = paths['/routes/search']['get']['responses']['200']['content']['application/json'];
type SearchRoutesSearchGetError = paths['/routes/search']['get']['responses']['422']['content']['application/json'];
type GetRoutesRouteIdGetSchema = {
  method: 'get';
  url: '/routes/{route_id}';
  security: ['HTTPBearer'];
};
type GetRoutesRouteIdGetParameters = paths['/routes/{route_id}']['get']['parameters'];
type GetRoutesRouteIdGetData = paths['/routes/{route_id}']['get']['responses']['200']['content']['application/json'];
type GetRoutesRouteIdGetError = paths['/routes/{route_id}']['get']['responses']['422']['content']['application/json'];
type UpdateRoutesRouteIdPatchSchema = {
  method: 'patch';
  url: '/routes/{route_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateRoutesRouteIdPatchParameters = paths['/routes/{route_id}']['patch']['parameters'];
type UpdateRoutesRouteIdPatchData =
  paths['/routes/{route_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateRoutesRouteIdPatchError =
  paths['/routes/{route_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateRoutesRouteIdPatchBody = paths['/routes/{route_id}']['patch']['requestBody']['content']['application/json'];
type DeleteRoutesRouteIdDeleteSchema = {
  method: 'delete';
  url: '/routes/{route_id}';
  security: ['HTTPBearer'];
};
type DeleteRoutesRouteIdDeleteParameters = paths['/routes/{route_id}']['delete']['parameters'];
type DeleteRoutesRouteIdDeleteData = null;
type DeleteRoutesRouteIdDeleteError =
  paths['/routes/{route_id}']['delete']['responses']['422']['content']['application/json'];
type DeleteRoutesRouteIdDeleteBody = undefined;
type CreateRoutesPostSchema = {
  method: 'post';
  url: '/routes';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateRoutesPostParameters = {
  query?: never;
  header?: never;
  path?: never;
};
type CreateRoutesPostData = paths['/routes']['post']['responses']['201']['content']['application/json'];
type CreateRoutesPostError = paths['/routes']['post']['responses']['422']['content']['application/json'];
type CreateRoutesPostBody = paths['/routes']['post']['requestBody']['content']['application/json'];
